import type { RoleType } from '@/features/role/domain/enums/RoleType'

export class CancelOrderReasonMiniEntity {
  id?: number
  role?: RoleType
  title?: string | null
  requiresUnavailableItems?: boolean
}
